module.exports = require('./lib/refs');

module.exports.Collection = require('./lib/collection');


// WEBPACK FOOTER //
// ./~/object-refs/index.js